// frontend/src/components/UserAvatar.jsx
import { useState, useRef, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ChangePasswordModal from './ChangePasswordModal';

export default function UserAvatar() {
    const [showDropdown, setShowDropdown] = useState(false);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const dropdownRef = useRef(null);

    const { user, logout } = useAuth();

    // Fechar dropdown ao clicar fora
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    if (!user) return null;

    // Gerar iniciais
    const initials = user.full_name
        .split(' ')
        .map(n => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);

    const handleLogout = () => {
        if (window.confirm('Deseja realmente sair?')) {
            logout();
        }
    };

    return (
        <>
            <div className="user-avatar-container" ref={dropdownRef}>
                <div
                    className="avatar-circle"
                    onClick={() => setShowDropdown(!showDropdown)}
                    title={user.full_name}
                >
                    {initials}
                </div>

                {showDropdown && (
                    <div className="avatar-dropdown">
                        <div className="dropdown-header">
                            <strong>{user.full_name}</strong>
                            <small className="text-muted d-block">@{user.username}</small>
                            {user.role_name && (
                                <span className="badge bg-secondary mt-1">{user.role_name}</span>
                            )}
                        </div>

                        <div className="dropdown-divider"></div>

                        <button
                            className="dropdown-item"
                            onClick={() => {
                                setShowPasswordModal(true);
                                setShowDropdown(false);
                            }}
                        >
                            <i className="bi bi-key me-2"></i>
                            Trocar Senha
                        </button>

                        <div className="dropdown-divider"></div>

                        <button
                            className="dropdown-item text-danger"
                            onClick={handleLogout}
                        >
                            <i className="bi bi-box-arrow-right me-2"></i>
                            Sair
                        </button>
                    </div>
                )}
            </div>

            <ChangePasswordModal
                show={showPasswordModal}
                onClose={() => setShowPasswordModal(false)}
                onSuccess={() => setShowPasswordModal(false)}
            />

            <style>{`
        .user-avatar-container {
          position: relative;
        }

        .avatar-circle {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 14px;
          cursor: pointer;
          transition: transform 0.2s, box-shadow 0.2s;
          user-select: none;
        }

        .avatar-circle:hover {
          transform: scale(1.1);
          box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        }

        .avatar-dropdown {
          position: absolute;
          top: 50px;
          right: 0;
          background: white;
          border: 1px solid #dee2e6;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          min-width: 220px;
          z-index: 1050;
          animation: fadeIn 0.2s ease-in;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .dropdown-header {
          padding: 12px 16px;
        }

        .dropdown-item {
          display: block;
          width: 100%;
          padding: 10px 16px;
          border: none;
          background: none;
          text-align: left;
          cursor: pointer;
          transition: background 0.2s;
        }

        .dropdown-item:hover {
          background: #f8f9fa;
        }

        .dropdown-divider {
          height: 1px;
          background: #dee2e6;
          margin: 0;
        }
      `}</style>
        </>
    );
}
